<template>
    <svg width="101px" height="100px" viewBox="0 0 101 100" class="spinnerSVG">
        <defs>
            <linearGradient id="linearGradient-1" x1="28%" y1="50%" x2="100%" y2="50%">
                <stop stop-color="#5B74FF" offset="0%"></stop>
                <stop stop-color="#5B74FF" stop-opacity="0.82" offset="38%"></stop>
                <stop stop-color="#5B74FF" stop-opacity="0.47" offset="57%"></stop>
                <stop stop-color="#5B74FF" stop-opacity="0.21" offset="75%"></stop>
                <stop stop-color="#5B74FF" stop-opacity="0.06" offset="90%"></stop>
                <stop stop-color="#FFFFFF" stop-opacity="0" offset="100%"></stop>
            </linearGradient>
            <path
                id="path-2"
                d="M33.3333333,0 C51.742825,0 66.6666667,14.9238417 66.6666667,33.3333333 C66.6666667,51.742825 51.742825,66.6666667 33.3333333,66.6666667 C14.9238417,66.6666667 0,51.742825 0,33.3333333 C0,14.9238417 14.9238417,0 33.3333333,0 Z M33.3333333,6.5040648 C18.5159375,6.5040648 6.5040648,18.5159375 6.5040648,33.3333333 C6.5040648,48.1507292 18.5159375,60.1626019 33.3333333,60.1626019 C48.1507292,60.1626019 60.1626019,48.1507292 60.1626019,33.3333333 C60.1626019,26.2177689 57.3359549,19.3936395 52.304491,14.3621756 C47.2730272,9.33071176 40.4488978,6.5040648 33.3333333,6.5040648 Z"
            ></path>
        </defs>
        <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g
                id="Icons-/-Search-Icons-/-Regular-/-Spinner"
                transform="translate(0.307339, 0.000000)"
            >
                <g id="Group" transform="translate(16.666667, 16.666667)">
                    <mask id="mask-3" fill="white">
                        <use xlink:href="#path-2"></use>
                    </mask>
                    <use
                        id="Spinner"
                        fill="url(#linearGradient-1)"
                        fill-rule="nonzero"
                        xlink:href="#path-2"
                    ></use>
                    <path
                        id="Combined-Shape"
                        d="M33.3333333,-3.55271368e-13 C51.742825,-3.55271368e-13 66.6666667,14.9238417 66.6666667,33.3333333 L60.1626019,33.3333333 L60.1626019,33.3333333 C60.1626019,26.2177689 57.3359549,19.3936395 52.304491,14.3621756 C47.2730272,9.33071176 40.4488978,6.5040648 33.3333333,6.5040648 C18.5159375,6.5040648 6.5040648,18.5159375 6.5040648,33.3333333 L0,33.3333333 C0,14.9238417 14.9238417,-3.55271368e-13 33.3333333,-3.55271368e-13 Z"
                        fill="#5B74FF"
                        fill-rule="nonzero"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'SpinnerSVG',
};
</script>

<style lang="scss" scoped>
.spinnerSVG {
    position: absolute;
    top: 58px;
    left: 58px;
    animation: rotation 2s infinite linear;

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }
}
</style>
